import React, { useCallback } from 'react';
import { getDescendantProperty } from '../utilities/objectUtilities';

function IndexView({
    columns,
    items,
    currentSortBy,
    isCurrentSortDescending,
    onSort,
    onItemClick
}) {

    const headers = useCallback(
        renderHeaders, 
        [columns, currentSortBy, isCurrentSortDescending, onSort]
    );
    
    const rows = useCallback(
        renderRows,
        [items, columns, onItemClick]
    );

    function renderHeaders() {
        return columns.map(column => {
            if (column.isSortable)
            {
                return (
                    <th key={column.name} scope='col'><button className='btn btn-sort' onClick={() => onSort(column.name)}>
                        {column.display}
                        {currentSortBy === column.name && <i className={`bi bi-arrow-${isCurrentSortDescending ? 'down' : 'up'} ms-2`}></i>}
                    </button></th>
                );
            }

            return (
                <th key={column.name} scope='col'>{column.display}</th>
            );
        });
    }

    function renderRows() {
        return items.map(item => {

            
            let cells = columns.map(column => <td key={column.name + item.id}>{column.formatFunction ? column.formatFunction(getDescendantProperty(item, column.name)) : getDescendantProperty(item, column.name)}</td>);
            return (
                <tr key={item.id} onClick={() => onItemClick(item)} class="cursor-pointer">
                    {cells}
                </tr>
            );
        });
    }

    return (
        <table className='table table-striped table-hover'>
            <thead>
                <tr>
                    {headers()}
                </tr>
            </thead>
            <tbody>
                {rows()}
            </tbody>
        </table>
    );
}

export default IndexView;